function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @namespace source.trash
 */

/**
 * @typedef Trash
 * @type Object
 */
import { toError } from './parsers/error';

function mapTrashParams(items, folders, settings) {
  items = items || [];
  folders = folders || [];
  var postData = {
    trash_files_id_list: items.map(function (item) {
      return item.id;
    }),
    trash_folders_id_list: folders.map(function (folder) {
      return folder.id;
    })
  };

  if (settings.namespace) {
    postData.ns = settings.namespace;
  }

  return postData;
}

export function initTrash(settings, http) {
  var mapResponse = function mapResponse(response) {
    return _objectSpread({}, response, {
      data: {
        opId: response.data.op_id
      },
      paging: {
        size: null,
        cursor: null
      }
    });
  };
  /**
   * @summary Remove all items in trash
   * @memberof source.trash
   * @param items Array
   * @param folders Array
   * @returns {Promise}
   * @reject {Error}
   */


  function remove(items, folders) {
    var url = settings.apiUrl + "/site/media/trash/delete";
    var data = mapTrashParams(items, folders, settings);
    return http.post(url, data).then(mapResponse)["catch"](toError);
  }
  /**
   * @summary Restore all items in trash
   * @memberof source.trash
   * @param items Array
   * @param folders Array
   * @returns {Promise}
   * @reject {Error}
   */


  function restore(items, folders) {
    var url = settings.apiUrl + "/site/media/trash/restore";
    var data = mapTrashParams(items, folders, settings);
    return http.post(url, data).then(mapResponse)["catch"](toError);
  }
  /**
   * Empty trash
   * @param options
   * @returns {Promise}
   */


  function empty(options) {
    options = options || {};
    var url = settings.apiUrl + "/site/media/trash/empty";
    var payload = options.mediaType ? {
      media_type: options.mediaType
    } : {};
    var postOptions = {
      headers: options.headers || {}
    };

    if (settings.namespace) {
      payload.ns = settings.namespace;
    }

    return http.post(url, payload, null, postOptions).then(mapResponse)["catch"](toError);
  }

  return {
    remove: remove,
    restore: restore,
    empty: empty
  };
}